



































































































































































import { Component, Vue } from "vue-property-decorator";
import { Company, User, PartialPermission, VueRoot } from "./domain";
import CompanyAdd from "@/components/CompanyAdd.vue";
import LangModal from "@/components/LangModal.vue";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import { getSidebarSections, MenuSection } from "@/domain/sidebar";
import { getUserStartPage } from "./modules/router";

@Component({ components: { CompanyAdd, LangModal } })
export default class App extends Vue {
  drawer = null;
  companyAdd = false;
  submenuShow = false;
  submenuSearch = "";
  dialog = false;

  created() {
    this.$root.$on("company-add", () => (this.companyAdd = true));
  }

  mounted() {
    const yourScript = document.createElement("script");
    yourScript.setAttribute("src", "https://status.paytef.es/embed/script.js");
    document.head.appendChild(yourScript);
  }

  openDialog() {
    this.dialog = !this.dialog;
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get currentYear() {
    const date = new Date();
    return date.getFullYear();
  }

  get lastRemoteError(): string | null {
    if (this.$store.state.lastError) {
      return "Se produjo un error consultando los datos";
    }
    return null;
  }

  get userCompaniesLoading(): boolean {
    return this.$store.state.userCompaniesLoading;
  }

  get userCompanies(): Company[] {
    return this.$store.state.userCompanies || [];
  }

  get submenuCompanies(): Company[] | null {
    const term = util.normalize(this.submenuSearch);
    return this.userCompanies.filter((c) => !term || util.normalize(c.name).includes(term));
  }

  get isLoading(): boolean {
    return this.currentCompanyLoading || this.userCompaniesLoading;
  }

  get currentCompanyLoading(): boolean {
    return this.$store.state.selectedCompanyLoading;
  }

  get currentCompany(): Company | null {
    return this.$store.state.selectedCompany;
  }

  get isUserLoaded(): boolean {
    return (
      !!this.currentUser &&
      !this.$store.state.currentUserLoading &&
      !this.userCompaniesLoading &&
      !this.$store.state.needsReinforcedLogin
    );
  }

  get currentUser(): User | null {
    return this.$store.state.currentUser;
  }

  get userPermission(): PartialPermission {
    return this.$store.getters.userPermission;
  }

  get isCompanySelected(): boolean {
    return this.currentUser !== null && this.currentCompany !== null;
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  get homePage(): string {
    return getUserStartPage();
  }

  async cmdLogout() {
    try {
      await this.$store.dispatch("logout");
    } catch (e) {
      util.logError("Error logging out", 2);
    }
    uiUtil.routePush(this, "/authlogin");
  }

  cmdAddCompany() {
    this.submenuShow = false;
    this.companyAdd = true;
  }

  async cmdSelectCompany(company: Company | null) {
    this.submenuShow = false;
    try {
      await this.$store.dispatch("selectCompany", company);
    } catch (e) {
      util.logError("Error selecting company", e);
    }
    if (company === null) {
      uiUtil.routePush(this, "/companyCatalog");
    }
  }

  cmdRetryLoadCompanies() {
    util.promiseEnd(this.$store.dispatch("refreshCompanies"));
  }

  cmdRetrySelectCompany() {
    util.promiseEnd(this.$store.dispatch("refreshCompany"));
  }

  get itemGroups(): MenuSection[] {
    return getSidebarSections(this.currentCompany, this.currentUser, this.userPermission);
  }
}
